import { render } from "./FormComponent.vue?vue&type=template&id=313dcff4"
import script from "./FormComponent.vue?vue&type=script&lang=js"
export * from "./FormComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\activa-nexus-contacto\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__